import Swiper from 'swiper/bundle'

class Slider {
  constructor () {
    this.init()
  }

  init () {
    // Posts slider
    const sliderPosts = new Swiper('.c-postsSlider__wrapper', { // eslint-disable-line
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        clickable: true
      },
      breakpoints: {
        1024: {
          loop: true,
          slidesPerView: 3,
          resizeObserver: true
        }
      }
    })

    // Hero Slider con efecto fade
    const heroslider = new Swiper(".homeswiper", { // eslint-disable-line
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      lazy: true,
      preloadImages: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    })

    // Servicios
    const sliderHomeBl3 = new Swiper('.c-home_bloque3__containerBck2', {
      direction: 'horizontal',
      watchOverflow: true,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-home_bloque3-button-next',
        prevEl: '.swiper-home_bloque3-button-prev'
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 25
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 25
        },
        1920: {
          slidesPerView: 4,
          spaceBetween: 25
        }
      },
      on: {
        afterInit: function (swiper) {
          if (swiper.slides.length <= 1) {
            swiper.navigation.destroy()
            const nextBtn = document.querySelector('.swiper-home_bloque3-button-next')
            const prevBtn = document.querySelector('.swiper-home_bloque3-button-prev')
            if (nextBtn) nextBtn.style.display = 'none'
            if (prevBtn) prevBtn.style.display = 'none'
          }
        }
      }
    })

    document.querySelectorAll('.c-home_bloque3__image').forEach(img => {
      if (img.complete) {
        sliderHomeBl3.update()
      } else {
        img.addEventListener('load', function () {
          sliderHomeBl3.update()
        })
      }
    })

    // Blog Posts Related - Swiper
    const sliderBlogPosts = new Swiper('.mySwiperlastposts', { // eslint-disable-line
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 0,
        stretch: -25,
        depth: 0,
        modifier: 1,
        slideShadows: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      loop: true,
      initialSlide: 0,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
          effect: 'slide',
          coverflowEffect: undefined
        }
      }
    })
  }

  reload () {
    this.init()
  }
}

export default Slider
